import { abort } from 'process'
import React, { FunctionComponent, useRef, useEffect } from 'react'
import { Button } from 'react-bootstrap'

interface DialogProps {
  isOpen: boolean
  verificationText: string
  submitText?: string
  abortText?: string
  buttonVariant?: string
  callbackSubmit: () => void
  callbackClose?: () => void
}

const Dialog: FunctionComponent<DialogProps> = ({
  isOpen,
  verificationText,
  submitText,
  abortText,
  buttonVariant,
  callbackSubmit,
  callbackClose,
}) => {
  const dialogRef = useRef<HTMLDialogElement>(null)

  const closeDialog = () => {
    dialogRef.current?.close()
    callbackClose && callbackClose()
  }

  useEffect(() => {
    isOpen && dialogRef.current?.showModal()
  }, [isOpen])

  return (
    <>
      {isOpen && (
        <dialog className="dialog p-4" ref={dialogRef}>
          <p>{verificationText}</p>
          <div className={`d-flex ${submitText && abortText ? 'justify-content-between' : 'justify-content-center'}`}>
            {submitText && (
              <Button variant={buttonVariant != null ? buttonVariant : 'primary'} onClick={() => callbackSubmit()}>
                {submitText}
              </Button>
            )}
            {abortText && (
              <Button variant="outline-secondary" onClick={() => closeDialog()}>
                {abortText}
              </Button>
            )}
          </div>
        </dialog>
      )}
    </>
  )
}

export default Dialog
